const placeholder = '__WDS_VERSIONED_NS__';

export const versionedNamespace = placeholder.startsWith('wds_')
  ? placeholder
  : '';
